import { AbstractRenderer, BoxModelConstraint, BoxModelContext, ContentBox, HighChartsSVGUtil, SVG_NS } from '@blk/simba';
import { CommonChartUtil } from '@ddt-web/chart';
import { TabData } from '@ddt-web/data-service';
import { ChartDispatcher, IChartWorker, IHighChartsAttributesModel } from '@ddt-web/highchart-manager';
import * as isEmpty from 'lodash/isEmpty';

declare const Highcharts;


export class HighchartsSVGComponent extends AbstractRenderer<SVGGElement> {
	public name: string;
	public componentTemplate: SVGGElement;
	private configs: Array<any> = [];

	constructor(
		name: string,
		constraints: Partial<BoxModelConstraint>,
		public tabData: TabData | TabData[],
		public chartType: string,
		public customAttributes?: any,
		private widthOffset?: number,
		private portfolioIndex?: number,
		private highChartsAttributes?: IHighChartsAttributesModel
	) {
		super(constraints);
		this.name = name;
	}

	private setupChartConfig(width: number, height: number): void {
		/**If we have high chart attributes we'll use our new HighCharts lib to generate the Chart SVG;
		 *eventually everything will migrate to this approach */
		if (this.highChartsAttributes) {
			const chartDispatcher = new ChartDispatcher(this.highChartsAttributes);
			const worker: IChartWorker = chartDispatcher.createWorker();
			worker.transformData();
			this.configs = [worker.config];
		} else if (this.tabData) {
			this.configs = CommonChartUtil.getChartConfigForPDF(this.chartType, this.name, this.tabData, width, height, this.customAttributes, this.portfolioIndex);
		}
	}

	protected renderContent(context: BoxModelContext): ContentBox<SVGGElement> {
		let widthConstraint: number = context.availableWidth;
		widthConstraint = this.widthOffset ? this.widthOffset + widthConstraint : widthConstraint;
		const heightConstraint: number = context.availableHeight;
		this.componentTemplate = this.initTemplate(widthConstraint, heightConstraint);
		this.setupChartConfig(widthConstraint, heightConstraint);
		if (this.configs && !isEmpty(this.configs)) {
			const charts = this.configs.map(config => Highcharts.chart(config));
			const hcWrapper = HighChartsSVGUtil.getSVGAndConvertToG(charts);
			hcWrapper.setAttribute('width', widthConstraint.toString());
			hcWrapper.setAttribute('height', heightConstraint.toString());
			this.componentTemplate = hcWrapper;
		}
		return new ContentBox(this.componentTemplate, widthConstraint, heightConstraint);
	}

	private initTemplate(width: number, height: number): SVGGElement {
		const template: SVGGElement = document.createElementNS(SVG_NS, 'g') as SVGGElement;
		template.setAttribute('width', `${width}`);
		template.setAttribute('height', `${height}`);
		template.setAttribute('style', 'overflow="visible"');
		return template;
	}
}
